import React from 'react';
import { Phone, HeartHandshake } from 'lucide-react';

const EmployeeRelations = () => {
  return (
    <div className="min-h-screen bg-green-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-green-800 sm:text-4xl">
            Employee Relations
          </h1>
        </div>
        
        <div className="mt-12 bg-white shadow-lg rounded-lg overflow-hidden border-b-4 border-orange-500">
          <div className="px-6 py-8">
            <div className="prose prose-lg max-w-none">
              <div className="flex items-center justify-center mb-8">
                <div className="bg-orange-100 p-3 rounded-full inline-block">
                  <HeartHandshake className="h-8 w-8 text-green-600" />
                </div>
              </div>
              <p className="text-gray-600 leading-relaxed mb-8">
                At SBG, employee relations supports and advocates for all employees. Whether addressing workplace concerns, 
                providing guidance on company policies, or assisting with conflict resolution, employee relations foster 
                a positive and inclusive work environment. With a focus on open communication and fair treatment, SBG's 
                employees strive to ensure that employees feel supported, valued, and heard. We aim to promote a healthy, 
                collaborative workplace where employees can thrive and contribute.
              </p>

              <div className="flex items-center justify-center my-8 p-6 bg-orange-50 rounded-lg">
                <div className="bg-orange-100 p-2 rounded-full mr-3">
                  <Phone className="w-5 h-5 text-green-600" />
                </div>
                <p className="text-lg font-medium text-green-800">
                  The Employee Relations Department may be reached at (602) 400-8028
                </p>
              </div>

              <div className="bg-white p-6 rounded-lg border-l-4 border-orange-500 shadow-md">
                <h2 className="text-xl font-semibold text-green-800 mb-4">
                  Confidentiality Commitment
                </h2>
                <p className="text-gray-600 leading-relaxed">
                  All calls to the Employee Relations Department are handled with the utmost confidentiality. 
                  Our dedicated team understands the sensitive nature of employee concerns and ensures that all 
                  information shared is kept strictly confidential. We prioritize the privacy and trust of our 
                  employees, and every conversation is conducted with the highest level of discretion. Rest assured 
                  that when contacting the Employee Relations Department at SBG, your privacy and confidentiality 
                  are our top priorities.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeRelations;
